module.exports = __webpack_public_path__ + "img/people.b28e6c84.png";